const niftyExpiries = [
  "16-Dec-2025",
  "23-Dec-2025",
  "30-Dec-2025",
  "06-Jan-2026",
  "13-Jan-2026",
  "27-Jan-2026",
  "24-Feb-2026",
  "31-Mar-2026",
  "30-Jun-2026",
  "29-Sep-2026",
  "29-Dec-2026",
  "29-Jun-2027",
  "28-Dec-2027",
  "27-Jun-2028",
  "26-Dec-2028",
  "26-Jun-2029",
  "24-Dec-2029",
  "25-Jun-2030",
];

const otherExpiries = [
  "30-Dec-2025",
  "27-Jan-2026",
  "24-Feb-2026",
  "31-Mar-2026",
  "30-Jun-2026",
  "29-Sep-2026",
];

export const EXPIRIES: { [key: string]: string[] }= {
  "Nifty": niftyExpiries,
  "Bank Nifty": otherExpiries,
  "Fin Nifty": otherExpiries,
};
